// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__tDvQo","spin":"styles_spin__M040C"};